var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col mb-3" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "row no-gutters" }, [
        _c("div", { staticClass: "col-sm-2 enrolled-course-card" }),
        _c("div", { staticClass: "col-sm-10" }, [
          _c("div", { staticClass: "card-body d-flex flex-column h-100" }, [
            _c("h5", { staticClass: "card-title mb-0" }, [
              _vm._v(_vm._s(_vm.course.name))
            ]),
            _c(
              "div",
              {
                staticClass: "h-100 d-flex flex-column justify-content-between"
              },
              [
                _c("div", { staticClass: "text-center course-star" }, [
                  _vm._v("⭐")
                ]),
                _c("div", { staticClass: "text-center" }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-primary text-white",
                      attrs: {
                        role: "button",
                        href: "/course/" + _vm.course.alias + "/"
                      }
                    },
                    [_vm._v(_vm._s(_vm.T.wordsSeeCourse))]
                  )
                ])
              ]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }